import { render, staticRenderFns } from "./manage-product-modal.vue?vue&type=template&id=95b32838&scoped=true&"
import script from "./manage-product-modal.vue?vue&type=script&lang=js&"
export * from "./manage-product-modal.vue?vue&type=script&lang=js&"
import style0 from "./manage-product-modal.vue?vue&type=style&index=0&id=95b32838&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95b32838",
  null
  
)

export default component.exports